import React from "react";
import { NavDropdown } from "react-bootstrap";
import NavBarMalumMortisX from "../../../assets/mork-borg/navbar-icon-malum-mortis.webp";

const ExquisiteCorpsesNavBar = () => {
  return (
    <NavDropdown title="Exquisite Corpses" id="exquisite-corpses-nav-dropdown">
      <NavDropdown.Header>
        <div style={{ textAlign: "center" }}>
          Exquisite Corpses
          <br />
          <small>Mork Borg Solo</small>
        </div>
      </NavDropdown.Header>

      <NavDropdown.Header>
        <img
          src={NavBarMalumMortisX}
          alt="Exquisite Corpses"
          style={{ maxHeight: 85 }}
        />
      </NavDropdown.Header>

      <NavDropdown title="Sessions" id="exquisite-corpses-sessions-dropdown">
        <NavDropdown.Item href="/mork-borg-session-01-exquisite-corpses">
          Solitary Defilement: Session 01
        </NavDropdown.Item>
        <NavDropdown.Item href="/mork-borg-session-00-exquisite-corpses">
          Solitary Defilement: Session 00
        </NavDropdown.Item>
      </NavDropdown>
    </NavDropdown>
  );
};

export default ExquisiteCorpsesNavBar;
